import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterAmountExchangeType } from './z-printer-amount-exhange-type';

@MappedClass()
export class ZPrinterAmountExchangeTypeApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedProperty()
  value: ZPrinterAmountExchangeType;
}
